module.exports = __webpack_public_path__ + "static/iso_1.0447747c.jpg";